import { createContext } from 'react';
import { ErrorHandlingContextValues } from './types/ErrorHandlingContextValues';

const ErrorHandlingContext = createContext<ErrorHandlingContextValues | undefined>(undefined);

export const ErrorHandlingProvider = ErrorHandlingContext.Provider;

export default ErrorHandlingContext;
